// export const url = "http://localhost/rest-api-ase/controllers/";

export const url = "https://ase-fsspx.com/rest-api-ase/controllers";
